// Copyright (c) 2016 Deere & Company

import React, {PropTypes} from 'react';
import {FormattedMessage} from 'react-intl';
import TransferEnterAor from '@deere/cps-it.warranty-model-factory/lib/transfer-enter-aor';

class TransfersAcceptAll extends React.Component {
    constructor() {

        super();
        this.handleClick = this.handleClick.bind(this);

    }

    handleClick() {

        this.props.transfers.forEach(transfer => {

            const newTransfer = {...transfer};

            newTransfer.status = 'ACCEPTED';
            this.props.updateAction(newTransfer);

        });

    }

    render() {

        return (
            <button
                className='button-primary'
                onClick={this.handleClick}
            >
                <FormattedMessage id='ACCEPT_ALL'/>
            </button>
        );

    }

}

TransfersAcceptAll.displayName = 'TransfersAcceptAll';
TransfersAcceptAll.propTypes = {
    transfers: PropTypes.arrayOf(PropTypes.instanceOf(TransferEnterAor)).isRequired,
    updateAction: PropTypes.func.isRequired
};

export default TransfersAcceptAll;



// WEBPACK FOOTER //
// ./src/product/transfers/components/transfers-accept-all.js